/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ProposedSolutionStep = (typeof ProposedSolutionStep)[keyof typeof ProposedSolutionStep];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProposedSolutionStep = {
  keep: "keep",
  create_recommended: "create_recommended",
  modify: "modify",
  cancel: "cancel",
} as const;
